export var ScheduleHeight = {
    navigation: 60,
    openedPlanRow: 30,
    closedRow: 31,
    scrollBar: 10,
    largeProcessBaseHeight: 103,
    largeProcessCollapsedHeight: 56,
    addButtonHeight: 40
};
export var ScheduleTypes;
(function (ScheduleTypes) {
    ScheduleTypes["Basic"] = "basic";
    ScheduleTypes["Changed"] = "changed";
    ScheduleTypes["View"] = "view";
    ScheduleTypes["Print"] = "print";
    ScheduleTypes["Preview"] = "preview";
})(ScheduleTypes || (ScheduleTypes = {}));
export var ScheduleMutationTypes;
(function (ScheduleMutationTypes) {
    ScheduleMutationTypes["INIT_STATE"] = "INIT_STATE";
    ScheduleMutationTypes["FETCH_SCHEDULE"] = "FETCH_SCHEDULE";
    ScheduleMutationTypes["FETCH_SCHEDULES"] = "FETCH_SCHEDULES";
    ScheduleMutationTypes["FETCH_PUBLISHED_SCHEDULE"] = "FETCH_PUBLISHED_SCHEDULE";
    ScheduleMutationTypes["FETCH_PRINT_SETTINGS"] = "FETCH_PRINT_SETTINGS";
    ScheduleMutationTypes["FETCH_PUBLISHED_SCHEDULES"] = "FETCH_PUBLISHED_SCHEDULES";
    ScheduleMutationTypes["FETCH_LARGE_PROCESSES"] = "FETCH_LARGE_PROCESSES";
    ScheduleMutationTypes["SORT_LARGE_PROCESSES"] = "SORT_LARGE_PROCESSES";
    ScheduleMutationTypes["FETCH_SMALL_PROCESSES"] = "FETCH_SMALL_PROCESSES";
    ScheduleMutationTypes["FETCH_PUBLISHED_LARGE_PROCESSES"] = "FETCH_PUBLISHED_LARGE_PROCESSES";
    ScheduleMutationTypes["FETCH_PUBLISHED_SMALL_PROCESSES"] = "FETCH_PUBLISHED_SMALL_PROCESSES";
    ScheduleMutationTypes["CREATE_SCHEDULE_PLAN"] = "CREATE_SCHEDULE_PLAN";
    ScheduleMutationTypes["FETCH_SCHEDULE_PLANS"] = "FETCH_SCHEDULE_PLANS";
    ScheduleMutationTypes["UPDATE_SCHEDULE_PLAN"] = "UPDATE_SCHEDULE_PLAN";
    ScheduleMutationTypes["DELETE_SCHEDULE_PLAN"] = "DELETE_SCHEDULE_PLAN";
    ScheduleMutationTypes["FETCH_PUBLISHED_SCHEDULE_PLANS"] = "FETCH_PUBLISHED_SCHEDULE_PLANS";
    ScheduleMutationTypes["EXIST_SCHEDULE"] = "EXIST_SCHEDULE";
    ScheduleMutationTypes["EXIST_PUBLISHED_SCHEDULE"] = "EXIST_PUBLISHED_SCHEDULE";
    ScheduleMutationTypes["DELETE_SCHEDULE"] = "DELETE_SCHEDULE";
    ScheduleMutationTypes["CREATE_LARGE_PROCESS"] = "CREATE_LARGE_PROCESS";
    ScheduleMutationTypes["UPDATE_LARGE_PROCESS"] = "UPDATE_LARGE_PROCESS";
    ScheduleMutationTypes["DELETE_LARGE_PROCESS"] = "DELETE_LARGE_PROCESS";
    ScheduleMutationTypes["CREATE_SMALL_PROCESS"] = "CREATE_SMALL_PROCESS";
    ScheduleMutationTypes["UPDATE_SMALL_PROCESS"] = "UPDATE_SMALL_PROCESS";
    ScheduleMutationTypes["DELETE_SMALL_PROCESS"] = "DELETE_SMALL_PROCESS";
    ScheduleMutationTypes["CREATE_PUBLISHED_SCHEDULE"] = "CREATE_PUBLISHED_SCHEDULE";
    ScheduleMutationTypes["UPDATE_PUBLISHED_SCHEDULE"] = "UPDATE_PUBLISHED_SCHEDULE";
    ScheduleMutationTypes["CHANGE_GANTT_WIDTH"] = "CHANGE_GANTT_WIDTH";
    ScheduleMutationTypes["CHANGE_GANTT_CHART_POSITION"] = "CHANGE_GANTT_CHART_POSITION";
    ScheduleMutationTypes["UPDATE_LARGE_PROCESS_FILETER_STATUSES"] = "UPDATE_LARGE_PROCESS_FILETER_STATUSES";
    ScheduleMutationTypes["CHANGE_SIDEMENU_HEIGHT"] = "CHANGE_SIDEMENU_HEIGHT";
    ScheduleMutationTypes["CHANGE_IS_SCHEDULE_STATUS"] = "CHANGE_IS_SCHEDULE_STATUS";
    ScheduleMutationTypes["CHANGE_IS_OPENED_STATUS_DIALOG"] = "CHANGE_IS_OPENED_STATUS_DIALOG";
    ScheduleMutationTypes["UPDATE_SCHEDULE_PLANS_OPENED"] = "UPDATE_SCHEDULE_PLANS_OPENED";
    ScheduleMutationTypes["UPDATE_LARGE_PROCESS_OPENED"] = "UPDATE_LARGE_PROCESS_OPENED";
    ScheduleMutationTypes["UPDATE_PUBLISHED_LARGE_PROCESS_OPENED"] = "UPDATE_PUBLISHED_LARGE_PROCESS_OPENED";
    ScheduleMutationTypes["UPDATE_IS_OPENED_ANY_LIST_ITEM"] = "UPDATE_IS_OPENED_ANY_LIST_ITEM";
    ScheduleMutationTypes["TOGGLE_COMPACT_MODE"] = "TOGGLE_COMPACT_MODE";
    ScheduleMutationTypes["SET_ALL_COMPACT_MODE"] = "SET_ALL_COMPACT_MODE";
})(ScheduleMutationTypes || (ScheduleMutationTypes = {}));
// Default "no color" value - represents no color in database
export var DEFAULT_NO_COLOR = '#D6D6D6';
export var DEFAULT_NO_COLOR_BORDER = '#B4B4B4';
/**
 * Converts color value for API: if it's the default "no color", return empty string
 * @param color - Color value to convert
 * @returns Empty string if default color, otherwise the color value
 */
export function colorToApiValue(color) {
    if (!color || color === DEFAULT_NO_COLOR) {
        return '';
    }
    return color;
}
/**
 * Converts color value from API: if empty/null, return default "no color"
 * @param color - Color value from API
 * @returns Default color if empty/null, otherwise the color value
 */
export function colorFromApiValue(color) {
    if (!color || color === '') {
        return DEFAULT_NO_COLOR;
    }
    return color;
}
export var colorOptions = [
    { main: '#D6D6D6', border: '#B4B4B4' },
    { main: '#F98ABC', border: '#E6609C' },
    { main: '#E29D9E', border: '#E28687' },
    { main: '#FFC284', border: '#FFA64D' },
    { main: '#EED15E', border: '#EBBB44' },
    { main: '#9DE3E7', border: '#69D2D8' },
    { main: '#BCE79D', border: '#9FCB80' },
    { main: '#CDD8FF', border: '#A4B7FF' },
    { main: '#6BB5FF', border: '#2391FF' },
    { main: '#9D9FE7', border: '#8788CF' },
    { main: '#D29DE2', border: '#C874E1' },
    { main: '#7E7E7E', border: '#656565' }
];
export var ProcessStatus;
(function (ProcessStatus) {
    ProcessStatus["NOT_STARTED"] = "not_started";
    ProcessStatus["IN_PROGRESS"] = "in_progress";
    ProcessStatus["COMPLETED"] = "completed"; // 確認完了
})(ProcessStatus || (ProcessStatus = {}));
export var ProgressType;
(function (ProgressType) {
    ProgressType["PERCENTAGE"] = "percentage";
    ProgressType["ACTUAL_VALUE"] = "actual_value";
    ProgressType["REFER_TO_SMALL_PROCESS"] = "refer_to_small_process"; // 小工程を参照
})(ProgressType || (ProgressType = {}));
export var STATUS_OPTIONS = [
    { key: 1, value: '未着工' },
    { key: 2, value: '施工中' },
    { key: 3, value: '施工完了' }
];
export var PROGRESS_OPTIONS = [
    { key: ProgressType.PERCENTAGE, value: ProgressType.PERCENTAGE, label: '割合' },
    { key: ProgressType.ACTUAL_VALUE, value: ProgressType.ACTUAL_VALUE, label: '実数値' },
    {
        key: ProgressType.REFER_TO_SMALL_PROCESS,
        value: ProgressType.REFER_TO_SMALL_PROCESS,
        label: '小工程を参照'
    }
];
export var ProcessStatusLabel;
(function (ProcessStatusLabel) {
    ProcessStatusLabel["NORMAL"] = "is-normal";
    ProcessStatusLabel["CAUTION"] = "is-caution";
    ProcessStatusLabel["DELAY"] = "is-delay";
})(ProcessStatusLabel || (ProcessStatusLabel = {}));
